import React, {ReactNode} from "react";

export const FullWidthPageWrapper = (props: {children: ReactNode | ReactNode[]}) =>
    <div className="m-4 pb-4 md:m-8">{props.children}</div>;